import { render, staticRenderFns } from "./RolPermisosDetails.vue?vue&type=template&id=164a7b02"
import script from "./RolPermisosDetails.vue?vue&type=script&lang=js"
export * from "./RolPermisosDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports